export const redirectToLogin = () => {
  if (process.env.NODE_ENV === 'production') {
    window.location.replace('/');
  }
};
